export default "__VITE_ASSET__C_dC3RZR__"